<!--
  File name: Card.vue
  Program Description:
    - This component renders the title, content, and action of the card
    component
    - Used to render the Password Form details in the card
-->

<template>
  <v-card
    flat
    tile
  >
    <v-toolbar
      v-if="showTitle"
      flat
    >
      <v-toolbar-title>
        <slot name="title" />
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <slot name="content" />
    </v-card-text>
    <v-card-actions class="px-0">
      <slot name="action" />
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  name: 'Card',
  props: {
    showTitle: Boolean
  }
}
</script>
